"use client";

import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { authFetch } from "../../lib/authFetch";
import { API_BASE } from "../../lib/api";
import {
  captureFirstTouch,
  getAttribution,
  attributionAlreadySent,
  markAttributionSent,
} from "../../lib/attribution";

// Captures first-touch acquisition on first load and, once a recently
// created account is authenticated, posts it to the backend (first-touch,
// idempotent). Renders nothing.
//
// The recency guard avoids back-filling long-existing users with "direct"
// on their next login -- only genuinely new signups (created in the last
// week, generous enough to cover the email-confirmation gap) get a source.
export default function AttributionCapture() {
  const { session } = useAuth();

  useEffect(() => {
    captureFirstTouch();
  }, []);

  useEffect(() => {
    if (!session) return;
    if (attributionAlreadySent()) return;
    const createdMs = session.user?.created_at ? new Date(session.user.created_at).getTime() : 0;
    const isRecent = createdMs > 0 && Date.now() - createdMs < 7 * 24 * 60 * 60 * 1000;
    if (!isRecent) return;
    const a = getAttribution();
    if (!a) return;
    authFetch(`${API_BASE}/profile/attribution`, {
      method: "POST",
      body: JSON.stringify(a),
    })
      .then((r) => {
        if (r.ok) markAttributionSent();
      })
      .catch(() => {
        // best-effort; will retry on a future load until it succeeds
      });
  }, [session]);

  return null;
}
